import { ReactNode } from 'react';
import BgNsPill from '@britishgasenergy/react-nucleus/dist/nuc-components/NsPill';

import { NsIconProps } from 'components/common/ns-icon/NsIcon';

export type NsPillProps = {
  slot?: string;
  colour?: JSX.IntrinsicElements['ns-pill']['colour'];
  icon?: NsIconProps['type'];
  children?: ReactNode;
  testId?: string;
};

export const NsPill = ({
  slot,
  colour,
  icon,
  children,
  testId
}: NsPillProps) => {
  return (
    <BgNsPill slot={slot} colour={colour} icon={icon} data-testid={testId}>
      {children}
    </BgNsPill>
  );
};
